export const formatPrice = (value, locale = 'es-MX', currency = 'MXN') => {
  if (isNaN(value)) return '$0';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(value);
};
